import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Dashboard-style text button — `.page-btn` / `.page-btn--primary` from PageShell.
 */
function PageButton({ to, variant = 'ghost', className = '', children, ...rest }) {
  const v = variant === 'primary' ? 'page-btn--primary' : 'page-btn--ghost';
  const cls = `page-btn ${v}${className ? ` ${className}` : ''}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={cls} {...rest}>
      {children}
    </button>
  );
}

export default PageButton;
